module.exports = __webpack_public_path__ + "img/null.71fc0223.png";